import { useCallback } from 'react';
import { ContentColors, Flex, IconRefresh } from '@banhala/ui-kit';
import type { HeadlineReloadOneLineProps } from './types';
import { isNil } from '../../../../utils';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';
import { HTMLText } from '../../../HTMLText';

const RELOAD_ICON_SIZE = 16;
const RELOAD_CIRCLE_SIZE = 28;
const RELOAD_TOUCH_SIZE = 40;

export const HeadlineReloadOneLine = ({
  header,
  screen,
  onReload,
}: HeadlineReloadOneLineProps) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handlePressReload = useCallback(() => {
    if (isNil(header)) return;
    logAnalyticsEvent({
      name: 'CLICK_HEADLINE_ONE_LINE_RELOAD',
      analytics: { ...header.logging.analytics, ...(screen != null && { SCREEN: screen }) },
      ably_only_log: header.logging.ably_only_log,
    });
    onReload?.();
  }, [header, screen, onReload, logAnalyticsEvent]);

  if (isNil(header)) {
    return null;
  }

  return (
    <Flex.Row
      padding={{ horizontal: 16, vertical: 16 }}
      alignItems="center"
      gap={4}
    >
      <Flex flexShrink={1}>
        <HTMLText type="h5" numberOfLines={1} color="content_primary">
          {header.item.title}
        </HTMLText>
      </Flex>

      <Flex
        width={RELOAD_TOUCH_SIZE}
        height={RELOAD_TOUCH_SIZE}
        alignItems="center"
        justifyContent="center"
        onPress={handlePressReload}
      >
        <Flex.Center
          width={RELOAD_CIRCLE_SIZE}
          height={RELOAD_CIRCLE_SIZE}
          borderRadius={RELOAD_CIRCLE_SIZE / 2}
          borderWidth={1}
          borderColor="gray20"
        >
          <IconRefresh
            width={RELOAD_ICON_SIZE}
            height={RELOAD_ICON_SIZE}
            fill={ContentColors.content_pink_primary}
          />
        </Flex.Center>
      </Flex>
    </Flex.Row>
  );
};
